import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const labelMap = {
  home: "Home",
  accounts: "Accounts",
  aws: "AWS",
  azure: "Azure",
  gcp: "GCP",
  oci: "OCI",
  wiz: "Wiz",
  email: "Email",
  reports: "Reports",
  "create-account": "Create Account",
  "user-management": "User Management",
  agents: "Agents",
  healthops: "HealthOps",
  bulk: "Bulk Email",
  ec2: "EC2",
  s3: "S3",
  rds: "RDS",
  efs: "EFS",
  eks: "EKS",
  iam: "IAM",
  lambda: "Lambda",
  sagemaker: "SageMaker",
  bedrock: "Bedrock",
  "monthly-costs": "Monthly Costs",
  "health-events": "Health Events",
  "trusted-advisor": "Trusted Advisor",
  "compute-optimizer": "Compute Optimizer",
  "ad-users-groups": "AD Users & Groups",
  kpi: "KPI",
  "cost-intelligence": "Cost Intelligence",
  "it-compliance": "IT Compliance",
  networking: "Networking",
  devops: "DevOps Agent",
  "datadog-console": "Datadog Console",
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0 || (pathSegments.length === 1 && pathSegments[0] === "home")) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm">
      <Link
        to="/home"
        className="text-gray-400 hover:text-gray-600 transition-colors"
      >
        <Home size={14} />
      </Link>
      {pathSegments.map((segment, index) => {
        const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
        const isLast = index === pathSegments.length - 1;
        const label = labelMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);

        return (
          <React.Fragment key={path}>
            <ChevronRight size={12} className="text-gray-300" />
            {isLast ? (
              <span className="text-gray-700 font-medium">{label}</span>
            ) : (
              <Link
                to={path}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
